
import { useContext, useEffect, useState } from 'react'
import { ClientContext } from '../../contextApi/ClientContext';
import { AppContext } from '../../contextApi/ContextApi';
import { useNavigate, useParams } from 'react-router-dom';

export default function SearchBar({isDashboard}) {
  const {currentWebsite, accent_color, primary_color, setToastMessage, messagesOptions} = useContext(AppContext);
  const { productsList, moveToProductPage } = useContext(ClientContext);
  const [isSearch, setIsSearch] = useState(false);
  const [searchData,setSearchData] = useState("");
  const nav = useNavigate();
  const params = useParams();
  const [results, setResults] = useState([]);

  // handle the search bar effect and results display
  useEffect(() => {
    if (!searchData) {
      setResults([]);
      setIsSearch(false);
      return;
    }

    setIsSearch(true);

    const timeout = setTimeout(() => {
      const filtered = productsList.filter(item =>{
          return item.name.trim().toLowerCase().includes(searchData.toLowerCase()) || item.company.trim().toLowerCase().includes(searchData.toLowerCase());
      })

      setResults(filtered);
      setIsSearch(false);
    }, 500);

    // 👇 cancel previous search if user types again
    return () => clearTimeout(timeout);
  }, [searchData, productsList]);

  const deployResults = ()=>{
    if(results.length === 0){
      return <p key={`searchResultRow_empty`} className='searchResultRow' dir="rtl">לא נמצאו תוצאות תואמות לחיפוש</p>
    }
    return results.map((item, inx) =>{
      return <p key={`searchResultRow_inx_${inx}`} className='searchResultRow' dir="rtl" onClick={()=>{moveToProductPage(nav, currentWebsite, params, item, setToastMessage, messagesOptions, isDashboard, null);setSearchData("")}}>{item.name} ({item.company})</p>
    })
  }
  
  return (
    <div className='navbarUpperDiv_middle'>
      <input type="search" className='searchbar_input' placeholder={isDashboard ? "כאן הלקוח יכול לחפש מוצרים באתר" : 'חיפוש...'} onChange={isDashboard ? null : (e)=>{setSearchData(e.target.value); setIsSearch(true)}}/>
      {searchData !== "" &&  <div className='dynamicResultList' style={{backgroundColor: accent_color, color: primary_color}}>
        {isSearch ? <p key={`searchResultRow_inx_default`} className='searchResultRow' dir="rtl">מחפש...</p> : deployResults()}
      </div>}
    </div>
  )
}
